
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import TestimonialKeyword from './TestimonialKeyword';
import FAQKeyword from './FAQKeyword';

function Onlinetaxibookingmumbai() {



    const cardData =
    {
        keyword: 'Online Taxi Booking in Mumbai',
        heading: 'Vedant Travels:  Online Taxi Booking in Mumbai',
        headingDescription: 'Vedant Travels offers a seamless online taxi booking service in Mumbai, providing a hassle-free and reliable travel experience. Whether you need a ride for airport transfers, corporate travel, outstation trips, or city commutes, our well-maintained fleet of sedans, SUVs, and luxury cars caters to all your travel needs. With professional drivers, 24/7 availability, and competitive fares, Vedant Travels ensures a comfortable and stress-free journey. Book your taxi online with us for a smooth and punctual travel experience across Mumbai and beyond.',

        top: 'Top Places to Visit in Mumbai with Vedant Travels',

"topPlaces": [
    {
        "title": "Gateway of India",
        "description": "The iconic Gateway of India is a grand archway overlooking the Arabian Sea. Built in 1924, it is a major tourist attraction and a historic landmark where visitors enjoy boat rides to Elephanta Caves."
    },
    {
        "title": "Marine Drive",
        "description": "Popularly known as the Queen’s Necklace, Marine Drive is a beautiful coastal boulevard offering stunning sunset views. The 3.6 km-long stretch is perfect for an evening stroll or relaxing by the sea."
    },
    {
        "title": "Chhatrapati Shivaji Maharaj Terminus (CSMT)",
        "description": "A UNESCO World Heritage Site, CSMT is an architectural marvel showcasing Victorian Gothic Revival style. This historic railway station is one of Mumbai’s busiest and most picturesque landmarks."
    },
    {
        "title": "Elephanta Caves",
        "description": "Located on Elephanta Island, these ancient rock-cut caves are dedicated to Lord Shiva. A UNESCO World Heritage Site, the caves feature intricate sculptures and are accessible by a short ferry ride from the Gateway of India."
    },
    {
        "title": "Colaba Causeway",
        "description": "A paradise for shoppers, Colaba Causeway is famous for its street shopping, cafés, and colonial-era architecture. It’s the perfect spot for picking up souvenirs and enjoying Mumbai’s vibrant street culture."
    },
    {
        "title": "Haji Ali Dargah",
        "description": "Situated on an islet off the coast of Worli, Haji Ali Dargah is a revered shrine built in Indo-Islamic style. It offers a serene atmosphere and is accessible via a causeway during low tide."
    },
    {
        "title": "Siddhivinayak Temple",
        "description": "Dedicated to Lord Ganesha, the Siddhivinayak Temple is one of Mumbai’s most visited religious sites. Devotees from across India come here to seek blessings and offer prayers."
    },
    {
        "title": "Juhu Beach",
        "description": "One of Mumbai’s most famous beaches, Juhu Beach is ideal for enjoying the sunset, tasting Mumbai’s street food like vada pav and pav bhaji, or simply relaxing by the sea."
    },
    {
        "title": "Sanjay Gandhi National Park & Kanheri Caves",
        "description": "A green oasis in the city, Sanjay Gandhi National Park is home to rich biodiversity and ancient Kanheri Caves, Buddhist rock-cut monuments dating back to the 1st century BCE."
    },
    {
        "title": "Bandra-Worli Sea Link",
        "description": "The Bandra-Worli Sea Link is an engineering marvel connecting South Mumbai to the western suburbs. The bridge offers breathtaking views of the city skyline, especially at night when it’s beautifully lit."
    }
],

"services": [
    {
        "name": "Online Taxi Booking Mumbai with Vedant Travels",
        "description": "Booking a taxi in Mumbai is easy and convenient with Vedant Travels. Our online taxi booking system ensures you get a reliable and comfortable ride in just a few clicks. Whether you need a ride for business, leisure, or any other purpose, we have you covered."
    },
    {
        "name": "Mumbai Taxi Booking Online",
        "description": "With Vedant Travels, booking a taxi in Mumbai online is a breeze. Our simple and quick online booking process ensures you can secure your ride in no time. Enjoy a comfortable, safe, and punctual taxi service whenever you need it."
    },
    {
        "name": "Mumbai Cab Online Booking",
        "description": "Need a cab in Mumbai? Use Vedant Travels for an easy and efficient online cab booking experience. Our fleet of well-maintained vehicles and professional drivers will make sure you have a smooth and enjoyable journey in Mumbai."
    },
    {
        "name": "Mumbai Car Rental Booking",
        "description": "Looking to rent a car in Mumbai? Vedant Travels offers an easy car rental booking service, allowing you to choose from a wide range of vehicles. Whether you're traveling alone, with family, or with a group, we have the perfect car for your needs."
    },
    {
        "name": "Mumbai Online Taxi Service",
        "description": "Vedant Travels provides a reliable online taxi service in Mumbai. Whether you're traveling within the city or heading to the airport, our online taxi service ensures a hassle-free experience. Book your ride anytime and enjoy a comfortable journey with experienced drivers."
    },
    {
        "name": "Mumbai Cab Booking Service",
        "description": "Our cab booking service in Mumbai is designed for convenience and comfort. With just a few taps, you can book a cab online and get picked up at your desired location. Trust Vedant Travels for punctual and professional cab services in Mumbai."
    },
    {
        "name": "Mumbai Online Taxi Fare",
        "description": "Vedant Travels offers transparent and competitive pricing for your Mumbai taxi rides. Our online taxi fares are clear with no hidden charges, allowing you to plan your journey without surprises. Contact us for an accurate fare estimate based on your trip details."
    },
    {
        "name": "Best Online Taxi Service Mumbai",
        "description": "When it comes to the best online taxi service in Mumbai, Vedant Travels is the trusted choice. Our user-friendly online booking system, combined with our fleet of comfortable vehicles and professional drivers, ensures you receive the best service every time."
    }
]
,



"tableData": [
    ["Online Taxi Booking Mumbai", "Mumbai Taxi Booking Online"],
    ["Mumbai Cab Online Booking", "Mumbai Car Rental Booking"],
    ["Mumbai Online Taxi Service", "Mumbai Cab Booking Service"],
    ["Mumbai Online Taxi Fare", "Best Online Taxi Service Mumbai"]
  ],
  "whychoose": [
    {
      "WhyChooseheading": "Reliable and On-Time Service",
      "WhyChoosedescription": "At Vedant Travels, we prioritize punctuality. Whether you're heading to an important business meeting, exploring the city, or traveling for leisure, our drivers ensure you reach your destination on time, every time."
    },
    {
      "WhyChooseheading": "Comfortable and Spacious Vehicles",
      "WhyChoosedescription": "Enjoy a relaxed journey with our fleet of well-maintained and spacious vehicles. We offer air-conditioned cars with comfortable seating, ample legroom, and a smooth ride, making your travel experience in Mumbai stress-free and enjoyable."
    },
    {
      "WhyChooseheading": "Experienced and Professional Drivers",
      "WhyChoosedescription": "Our team of drivers is professional, courteous, and highly experienced in navigating the busy streets of Mumbai. They are trained to provide you with the best route, ensuring a smooth, safe, and efficient journey across the city."
    },
    {
      "WhyChooseheading": "Affordable and Transparent Pricing",
      "WhyChoosedescription": "Vedant Travels offers competitive pricing with no hidden charges. We believe in complete transparency in our pricing structure, so you can plan your trip without any surprises. You get great value for your money."
    },
    {
      "WhyChooseheading": "Safe and Secure Travel",
      "WhyChoosedescription": "Your safety is our priority. All our vehicles are regularly maintained and equipped with modern safety features such as airbags, seat belts, and GPS tracking. Our drivers follow strict safety protocols to ensure a secure and worry-free ride."
    },
    {
      "WhyChooseheading": "24/7 Availability",
      "WhyChoosedescription": "Whether you need a taxi in the early morning, late at night, or in the middle of the day, Vedant Travels is available 24/7. We are always ready to assist you with your travel needs at any time."
    },
    {
      "WhyChooseheading": "Hassle-Free Booking Process",
      "WhyChoosedescription": "Booking your taxi in Mumbai is quick and easy. You can book online through our website or mobile app, or reach out to our customer service team for assistance. We aim to make the booking process as simple as possible."
    },
    {
      "WhyChooseheading": "Customized Travel Packages",
      "WhyChoosedescription": "We offer personalized travel experiences to suit your needs. Whether it's a one-way trip, round-trip, or a sightseeing tour, we can tailor your ride to fit your schedule and preferences. Enjoy your journey in Mumbai your way."
    }
  ]

    }
    const faqData = [
        {
            id: 1,
            question: 'How can I book a taxi online in Mumbai with Vedant Travels?',
            answer: 'You can easily book your taxi online via our website or mobile app. Alternatively, you can call our customer service team to assist you with your booking.',
        },
        {
            id: 2,
            question: 'What types of vehicles are available for booking in Mumbai?',
            answer: 'We offer a variety of vehicles, including sedans, SUVs, and luxury cars. All our cars are well-maintained, spacious, and equipped for a comfortable ride around the city.',
        },
        {
            id: 3,
            question: 'How do I pay for my taxi ride in Mumbai?',
            answer: 'We accept various payment methods, including cash, credit/debit cards, and online payments via our mobile app. We offer a secure and convenient payment process for your ease.',
        },
        {
            id: 4,
            question: 'Are there any additional charges for booking a taxi online?',
            answer: 'No, there are no hidden charges. Our pricing is transparent, and any additional costs, like tolls or waiting charges, are communicated upfront before booking.',
        },
        {
            id: 5,
            question: 'Can I book a round-trip taxi for Mumbai?',
            answer: 'Yes, you can book a round-trip taxi for your journey. Simply provide your return details during the booking, and we will handle the rest to ensure a seamless experience.',
        },
        {
            id: 6,
            question: 'Can I hire a taxi for sightseeing in Mumbai?',
            answer: 'Yes, we offer sightseeing tours in Mumbai. Visit iconic places such as the Gateway of India, Marine Drive, Colaba Causeway, and other attractions with an experienced driver.',
        },
        {
            id: 7,
            question: 'Can I book a taxi for corporate travel in Mumbai?',
            answer: 'Yes, we offer corporate travel services in Mumbai. Whether you\'re going for meetings, conferences, or corporate events, we provide professional taxi services to ensure your comfort and punctuality.',
        },
        {
            id: 8,
            question: 'What is the luggage allowance for a taxi in Mumbai?',
            answer: 'Our taxis are spacious enough to accommodate standard luggage. If you have excess or special luggage requirements, please inform us during the booking process, and we’ll make necessary arrangements.',
        },
        {
            id: 9,
            question: 'Is there a minimum booking duration for online taxi bookings in Mumbai?',
            answer: 'There is no minimum booking duration, but we recommend booking in advance for convenience. Whether you need a short or long ride, we are here to serve you.',
        },
        {
            id: 10,
            question: 'Why should I choose Vedant Travels for online taxi booking in Mumbai?',
            answer: 'Vedant Travels offers a reliable, affordable, and comfortable taxi service with experienced drivers, well-maintained vehicles, and transparent pricing. Whether for business, leisure, or sightseeing, we ensure a smooth and hassle-free ride in Mumbai.',
        },
    ];
    
    const testimonials = [
        {
            name: "Mr. Aditya Mehta",
            title: "Traveler",
            quote: "Booking a taxi through Vedant Travels was a breeze. The process was simple, and the driver was prompt and professional. I highly recommend them for anyone needing reliable and comfortable travel in Mumbai!",
            rating: 5,
        },
        {
            name: "Mrs. Anjali Deshmukh",
            title: "Regular Traveler",
            quote: "I’ve been using Vedant Travels for my regular trips around Mumbai, and I’m always satisfied. The cars are clean, the drivers are courteous, and the service is always on time. It’s my go-to choice for Mumbai taxi bookings.",
            rating: 5,
        },
    ];
    
    
    
    
    
    
    








    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 8767459909",

        ],
        email: "booking@vedanttravels.in"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];


    

  
const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Online Taxi Booking Mumbai",
  "image": "https://vedanttravels.in/assets/images/online-taxi-booking-mumbai.jpg",
  "description": "Book your taxi online in Mumbai with Vedant Travels for safe, reliable, and convenient rides. Choose from a range of vehicles including AC sedans, SUVs, and tempo travellers for city and outstation trips.",
  "brand": {
    "@type": "Brand",
    "name": "Vedant Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "5200"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "699",
    "availability": "https://schema.org/InStock",
    "url": "https://vedanttravels.in/online-taxi-booking-mumbai"
  }
};


  
   
      


    return (
        <div>
             
<Helmet>
  <title>Online Taxi Booking Mumbai | Safe & Reliable Rides | Vedant Travels</title>
  <meta 
    name="description" 
    content="Book your taxi online in Mumbai with Vedant Travels for safe, reliable, and convenient rides. Choose from a range of vehicles including AC sedans, SUVs, and tempo travellers for city and outstation trips." 
  />
  <meta 
    name="keywords" 
    content="Online Taxi Booking Mumbai, Mumbai Taxi Online Booking, Book Taxi Mumbai, Vedant Travels Mumbai, AC Cab Mumbai Online, SUV Taxi Mumbai Booking, Reliable Taxi Mumbai, Safe Taxi Booking Mumbai" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>
           
            <div
                className="site-breadcrumb"
                style={{ background: 'url(/img/breadcrumb/01.jpg)' }}
            >
                <div className="container">
                    <h2 className="breadcrumb-title">{cardData.keyword}</h2>

                </div>
            </div>

            <section id="about" className="jarallax text-light">
                <div className="center-y relative text-center">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 text-center">
                                <h1 className='text-white'>{cardData.keyword}</h1>
                            </div>
                            <div className="clearfix"></div>
                        </div>
                    </div>
                </div>
            </section>

            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/89.jpg' alt='img' />
                            <h3 className="py-1"
                                style={{
                                    color: '#322E77', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolorrr'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolorrr">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolorrr">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Vedant Travels</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <TestimonialKeyword testimonials={testimonials} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div>

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #006BB7',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#006BB7' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <i className="bi bi-telephone-fill fs-1 mb-2"></i>
                                            <div className=''>
                                                <a href="tel:+918767459909" className="d-block  text-white">+91 8767459909</a>
                                                


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <i className="bi bi-envelope fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@vedanttravels.in" className=" text-white d-block">
                                                    booking@vedanttravels.in
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <i className="bi bi-house-fill fs-1 mb-2"></i>
                                            <div className='rounded py-2' style={{ backgroundColor: '#006BB7' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Vedant Travels <br/>
                                                    S/R No. 66/1. Dhore Patil Farm,<br/>
                                                    Near New  Bharat Bakery,
                                                    New Sangvi <br/>Pimpri-Chinchwad,
                                                    Pune Maharashtra India- 411027.
                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Onlinetaxibookingmumbai;